import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../nest-api';
import { Observable } from 'rxjs';
import { ResponseData } from '../../nest-responses';
import { RequestTaskFeedBackDto } from '../dto/task-feedback-report.dto';

@Injectable()
export class TaskFeedbackReportApi {

  private readonly service: string = '';
  private readonly model: string = 'TaskFeedbackReport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public taskpreview(payload: RequestTaskFeedBackDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'taskpreview';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public taskReportSendEmail(payload: RequestTaskFeedBackDto): Observable<ResponseData<string>> {
    const method: string = 'POST';
    const func: string = 'taskReportSendEmail';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<string>>(method, url, params, urlParams, body);
  }

  public taskDownloadExcel(payload: RequestTaskFeedBackDto): Observable<ResponseData<Blob>> {
    const method: string = 'POST';
    const func: string = 'taskDownloadExcel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<ResponseData<Blob>>(method, url, params, urlParams, body);
  }

  public taskDownloadPdf(payload: RequestTaskFeedBackDto): Observable<ResponseData<Blob>> {
    const method: string = 'POST';
    const func: string = 'taskDownloadPdf';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<ResponseData<Blob>>(method, url, params, urlParams, body);
  }

  public feedbackpreview(payload: any): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'feedbackpreview';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public feedbackReportSendEmail(payload: any): Observable<ResponseData<string>> {
    const method: string = 'POST';
    const func: string = 'feedbackReportSendEmail';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<string>>(method, url, params, urlParams, body);
  }

  public feedbackDownloadExcel(payload: any): Observable<ResponseData<Blob>> {
    const method: string = 'POST';
    const func: string = 'feedbackDownloadExcel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<ResponseData<Blob>>(method, url, params, urlParams, body);
  }

  public feedbackDownloadPdf(payload: any): Observable<ResponseData<Blob>> {
    const method: string = 'POST';
    const func: string = 'feedbackDownloadPdf';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<ResponseData<Blob>>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/task-feedback-report.api.ts